import React from "react";
// Layout Types
import { DefaultLayout, MainLayout } from "../layouts";

// Route Views
import UserProfileLite from "../views/UserProfileLite";
import Login from "../pages/login/Login";
import Settings from "../pages/admin/Settings";
import Dashboard from "../pages/admin/Dashboard";
import Users from "../pages/admin/Users";
import StarredUsers from "../pages/admin/StarredUsers";
import DeletedUsers from "../pages/admin/DeletedUsers";
import Register from "../pages/register/Register";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Userdetails from "../pages/admin/userDetails/User-details";
import CalibtrationOverView from "../pages/admin/userDetails/CalibrationOverView";
import Queries from "../pages/admin/Queries";
import DeviceData from "../pages/admin/DeviceData";
import SubAdmins from "../pages/admin/subAdmin/SubAdmins";
import SubAdminDetails from "../pages/admin/subAdmin/SubAdminDetails";
import { useAuth } from "../providers/AuthProvider";
import AssignedUsers from "../pages/sub-admin/assigned-users";
import StudentDetails from "../pages/sub-admin/studentDetails/Student-details";
import StudentCalibtrationOverView from "../pages/sub-admin/studentDetails/StudentCalibrationOverView";
import SubAdminStudentsTrainingTracker from "../pages/admin/subAdmin/SubAdminStudentsTrainingTracker";
import ReminderList from "../pages/sub-admin/ReminderList";
import ResultsReport from "../pages/admin/userDetails/ResultsReport";
import Students from "../pages/admin/Students";
import SimpleUsersTable from "../pages/admin/SimpleUsers";

// const routes = [
//   {
//     path: "/",
//     exact: true,
//     layout: MainLayout,
//     component: Dashboard,
//     role: ['admin']
//   },
//   {
//     path: "/login",
//     layout: DefaultLayout,
//     component: Login,
//     role: []
//   },
//   {
//     path: "/register",
//     layout: DefaultLayout,
//     component: Register,
//     role: []
//   },
//   {
//     path: "/dashboard",
//     layout: MainLayout,
//     component: Dashboard,
//     role: ['admin']
//   },
//   {
//     path: "/users",
//     layout: MainLayout,
//     component: Users,
//     role: ['admin']

//   },
//   {
//     path: "/user-details/:id",
//     layout: MainLayout,
//     component: Userdetails,
//     role: ['admin']
//   },
//   {
//     path: "/settings",
//     layout: MainLayout,
//     component: Settings,
//     role: ['admin']
//   },
//   {
//     path: "/calibration-overview/:id",
//     layout: MainLayout,
//     component: CalibtrationOverView,
//     role: ['admin']
//   },
//   {
//     path: "/profile",
//     layout: MainLayout,
//     component: UserProfileLite,
//     role: ['admin']
//   },
//   {
//     path: "/device-data",
//     layout: MainLayout,
//     component: DeviceData,
//     role: ['admin']
//   },
//   {
//     path: "/sub-admins",
//     layout: MainLayout,
//     component: SubAdmins,
//     role: ['admin']
//   },
//   {
//     path: "/sub-admin-data/:id",
//     layout: MainLayout,
//     component: SubAdminDetails,
//     role: ['admin']
//   },
//   {
//     path: "/",
//     layout: MainLayout,
//     component: SubAdmins,
//     role: ['sub-admin']
//   },
// ];

const Routes = () => {
  const { userRole } = useAuth();
  let routes = [
    {
      path: "/login",
      layout: DefaultLayout,
      component: Login
    },
    {
      path: "/register",
      layout: DefaultLayout,
      component: Register
    },
    {
      path: "/",
      exact: true,
      layout: MainLayout,
      component: Users
    }
  ];

  let admin_routes = [
    {
      path: "/",
      exact: true,
      layout: MainLayout,
      component: SimpleUsersTable
    },
    {
      path: "/dashboard",
      layout: MainLayout,
      component: Dashboard
    },
    {
      path: "/users",
      layout: MainLayout,
      component: Users
    },
    {
      path: "/newUsers",
      layout: MainLayout,
      component: SimpleUsersTable
    },
    {
      path: "/starred-users",
      layout: MainLayout,
      component: StarredUsers
    },
    {
      path: "/deleted-users",
      layout: MainLayout,
      component: DeletedUsers
    },
    {
      path: "/user-details/:id",
      layout: MainLayout,
      component: Userdetails
    },
    {
      path: "/settings",
      layout: MainLayout,
      component: Settings
    },
    {
      path: "/calibration-overview/:id",
      layout: MainLayout,
      component: CalibtrationOverView
    },
    {
      path: "/profile",
      layout: MainLayout,
      component: UserProfileLite
    },
    {
      path: "/device-data",
      layout: MainLayout,
      component: DeviceData
    },
    {
      path: "/sub-admins",
      layout: MainLayout,
      component: SubAdmins
    },
    {
      path: "/sub-admin-data/:id",
      layout: MainLayout,
      component: SubAdminDetails
    },
    {
      path: "/sub-admin-students-tracking/:id/:name",
      layout: MainLayout,
      component: SubAdminStudentsTrainingTracker
    },
    {
      path: "/ResultsReport",
      layout: MainLayout,
      component: ResultsReport
    },
    {
      path: "/students",
      layout: MainLayout,
      component: Students
    }
  ];
  let teacher_routes = [
    {
      path: "/",
      layout: MainLayout,
      component: Students,
      exact: true
    },
    {
      path: "/students",
      layout: MainLayout,
      component: Students
    },
    {
      path: "/user-details/:id",
      layout: MainLayout,
      component: Userdetails
    },
    {
      path: "/sub-admin-students-tracking/:id/:name",
      layout: MainLayout,
      component: SubAdminStudentsTrainingTracker
    }
  ];

  let optician_routes = [
    {
      path: "/",
      layout: MainLayout,
      component: AssignedUsers,
      exact: true,
    },
    {
      path: "/users",
      layout: MainLayout,
      component: AssignedUsers,
    },
    {
      path: "/user-details/:id",
      layout: MainLayout,
      component: Userdetails,
    },
  ];

  let sub_admin_routes = [
    {
      path: "/",
      layout: MainLayout,
      component: AssignedUsers,
      exact: true,
    },
    // {
    //   path: "/dashboard",
    //   layout: MainLayout,
    //   component: SubAdminDashboard,
    // },
    {
      path: "/users",
      layout: MainLayout,
      component: AssignedUsers,
    },
    {
      path: "/reminder-list",
      layout: MainLayout,
      component: ReminderList,
    },
    {
      path: "/student-details/:id",
      layout: MainLayout,
      component: StudentDetails,
    },
    {
      path: "/user-details/:id",
      layout: MainLayout,
      component: Userdetails,
    },
    {
      path: "/student-calibration-overview/:id",
      layout: MainLayout,
      component: StudentCalibtrationOverView,
    },
  ];

  console.log("XXXXXX userRole:", userRole);

  if (userRole === "admin") {
    routes = routes.filter((route) => route.path !== "/");
    routes.push(...admin_routes);
  } else if (userRole === "sub-admin") {
    routes = routes.filter((route) => route.path !== "/");
    routes.push(...sub_admin_routes);
  } else if (userRole === "specialTeacher") {
    routes = routes.filter((route) => route.path !== "/");
    routes.push(...teacher_routes);
  } else if (userRole === "classTeacher") {
    routes = routes.filter((route) => route.path !== "/");
    routes.push(...teacher_routes);
  } else if (userRole === "principalTeacher") {
    routes = routes.filter((route) => route.path !== "/");
    routes.push(...teacher_routes);
  } else if (userRole === "optician") {
    routes = routes.filter((route) => route.path !== "/");
    routes.push(...optician_routes);
  }

  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    routes.push({
      path: "/queries",
      layout: MainLayout,
      component: Queries,
      role: []
    });
  }

  return (
    <Router>
      {routes.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={props => {
              return (
                <route.layout {...props}>
                  <route.component {...props} />
                </route.layout>
              );
            }}
          />
        );
      })}
    </Router>
  );
};
export default Routes;
